<template>
	<div
    class="tabs"
  >
    <div
      class="headerScroll"
      ref="scroll"
      @wheel="scrollOnWheel"
    >
      <div class="header">
        <div class="items">
          <div
            v-for="( tab, i ) in tabs"
            :key="tab.id_"
            ref="tabs"

            v-show="tab.show"

            class="item"

            :class="( !active && i === 0 ) || tab === active ? 'active' : ''"
            :title="tab.name"

            @click="tabChange( tab )"
          >
            <Icon
              v-if="tab.icon"
              :symbol="tab.icon"
            />
            <template v-else />

            {{ tab.name }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="scrollContent" class="content">
      <div class="scrollContent">
        <slot></slot>
      </div>
    </div>
		<div
      v-else
      class="content"
    >
			<slot></slot>
		</div>
	</div>
</template>

<script>
import Icon from "@/components/Icon"

export default {
	name:  "Tabs",
	components: {
	    Icon
  },
	props: {
		onClose: {
			type: Function,
			default: null
		},
    activeId: {
		  type: String,
      default: null
    },
    scrollContent: {
		  type: Boolean,
      default: true
    }
	},
	data() {
		return {
			active: null,
			tabs: [],
		};
	},
	created() {
		this.tabs = [];
	},
	async mounted() {
		if ( this.tabs.length ) {
		  await this.$nextTick();
			this.tabChange( this.activeId );
		}
	},
	methods: {
	  scrollOnWheel( e ) {
	    const el = this.$refs.scroll;
	    if ( el ) {
        const sw = el.scrollWidth - el.offsetWidth;
        const [ x, y ] = [ e.deltaX, e.deltaY];
        const shift = x == 0 ? ( y > 0 ? -30 : 30 ) : x;
        let sl = el.scrollLeft + shift;
        if ( sl < 0 ) sl = 0;
        if ( sl > sw ) sl = sw;
        if ( sl != el.scrollLeft ) {
          //el.scrollLeft = sl;
          el.scrollBy( { left: shift } );
          e.preventDefault();
        }
      }
    },
    tabEmit( tab, state ) {
	    let data = null;
	    if ( tab ) {
	      data = { id: tab.id_, name: tab.name, index: this.tabs.findIndex( t => t === tab ) };
	      tab.$emit( "active", { state, data } );
			  if ( state && this.$refs.tabs && this.$refs.tabs[ data.index ] ) this.$refs.tabs[ data.index ].scrollIntoView( { block: 'nearest', inline: "start" } );
      }
			this.$emit( "active", { state, data } );
    },

		tabChange( tab ) {
		  this.tabEmit( this.active, false );

			if ( !tab ) tab = this.tabs.find( i => i.show );
			if ( typeof( tab ) === "string" ) tab = this.tabs.find( i => i.id === tab );
			if ( !tab ) tab = null;

			this.active = tab;

			this.tabEmit( this.active, true );
		},

		getActive() {
			return this.active;
		}
	},

  watch: {
	  activeId() {
      this.tabChange( this.activeId );
    }
  }
}
</script>

<style scoped>
	.tabs {
		display: flex;
		flex-direction: column;
    align-items: stretch;
    --lineColor: #0081CA;
    --tabColor: #FFFFFF;
    --tabBgColor: #0081CA;
    --tabHoverBgColor: #40B8ED;
    --tabActiveColor: #0081CA;
    --tabActiveBgColor: #FFFFFF;
  }

  .headerScroll {
    transform: rotate( 180deg );
    scrollbar-width: thin;
    overflow-x: auto;
    overflow-y: hidden;
    flex-shrink: 0;
    flex-grow: 0;
  }
  .header {
    transform: rotate( -180deg );
		display: table;
    width: 100%;
		align-items: center;
		box-sizing: border-box;
    border: solid var(--lineColor);
    border-width: 0 0 1px 0;
    padding: 0 1em;
    position: relative;
  }
  .header:before {
    content: "";
    display: block;
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 1px;
    box-shadow: 0 -2px 3px rgba( 0, 0, 0, 0.7 );
    z-index: 1;
  }

	.content {
    flex-shrink: 0;
    flex-grow: 1;
    position: relative;
  }
  .scrollContent {
    position: absolute;
    top: 1em;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: auto;
  }

	.items {
    display: flex;
    flex-wrap: nowrap;
    justify-items: stretch;
    align-self: flex-start;
    align-items: flex-start;
		margin-right: 1em;
    flex-grow: 0;
    flex-shrink: 0;
    position: relative;
    top: 1px;
  }

	.item {
    padding: 0.2em 1em;
    background-color: var(--tabBgColor);
    color: var(--tabColor);
    border: solid 1px var(--lineColor);
    border-radius: 0.2em 0.2em 0 0;
    cursor: pointer;
    position: relative;
    margin: 2px -0.5em 0 0;
    max-width: 15em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: background-color,color .2s linear;
    box-shadow: 2px 0 3px rgba( 0, 0, 0, 0.7 ), -2px 0 3px rgba( 0, 0, 0, 0.7 );
/*    clip-path: inset( 0 -3px 0 -3px );*/
    top: 0;
  }
  .item:last-child {
    margin-right: 0;
  }
  .item:hover {
    color: var(--tabActiveColor);
    background-color: var(--tabActiveBgColor);
  }
  .item.active {
    border-bottom: solid 3px var(--tabActiveBgColor);
    z-index: 1;
    color: var(--tabActiveColor);
    background-color: var(--tabActiveBgColor);
    box-shadow: 2px 5px 3px rgba( 0, 0, 0, 0.7 ), -2px 5px 3px rgba( 0, 0, 0, 0.7 );
    margin-top: 0;
  }
  .item * {
    font-size: 1.5em;
    vertical-align: center;
  }
/*
  .contentWrapper:first-child {
    padding-top: 1em;
  }
*/
</style>